import { render, staticRenderFns } from "./FloatProfileUsers.vue?vue&type=template&id=f85525ec&scoped=true&"
import script from "./FloatProfileUsers.vue?vue&type=script&lang=ts&"
export * from "./FloatProfileUsers.vue?vue&type=script&lang=ts&"
import style0 from "./FloatProfileUsers.vue?vue&type=style&index=0&id=f85525ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f85525ec",
  null
  
)

export default component.exports